import Select from './Select';
import { getTimeZones } from '@vvo/tzdb';
import SelectOptgroup from './SelectOptgroup.jsx';

let optionsCache = null;

function getOptions() {
    // Don't recalc every render!
    if (optionsCache === null) {
        const timeZonesWithUtc = getTimeZones({ includeUtc: true });

        const optgroupOptions = {};
        timeZonesWithUtc
            .sort((a, b) => {
                // First, sort by offset
                return (
                    b.currentTimeOffsetInMinutes - a.currentTimeOffsetInMinutes
                );
            })
            .sort((a, b) => {
                // Then order so US is first
                if (a.countryCode === 'US' && b.countryCode !== 'US') {
                    return -1;
                } else {
                    return 0;
                }
            })
            .forEach(opt => {
                // optgroupOptions.push({
                //     key: opt.name,
                //     label: `GMT${opt.currentTimeFormat}`
                // })
                optgroupOptions[opt.countryCode] = {
                    label: opt.countryName,
                    options: {
                        ...optgroupOptions[opt.countryCode]?.options,
                        [opt.name]: `GMT${opt.currentTimeFormat}`,
                    },
                };
            });
        //.forEach((opt) => keyedOptions[opt.name] = `GMT${opt.currentTimeFormat}`)
        optionsCache = optgroupOptions;
    }

    return optionsCache;
}

const TimezoneSelect = ({
    value,
    onChange,
    label,
    id,
    className,
    inputClassName,
}) => {
    const optgroupOptions = getOptions();

    return (
        <SelectOptgroup
            id={id}
            label={label}
            className={className}
            value={value}
            onChange={onChange}
            options={Object.values(optgroupOptions)}
            inputClassName={inputClassName}
        />
    );
};

export default TimezoneSelect;
